var store = require('store')

const $storage = {
    storageKey: 'LinkUI',
    storage: store.get("LinkUI") || {},
    get(key) {
        return this.storage[key]
    },
    set(key, val) {
        this.storage[key] = val
        store.set(this.storageKey, this.storage)
    },
}

export default $storage
